import { useState, useEffect } from 'react'
import { useAuth } from '@/hooks/use-auth'
import { useNavigate, Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useToast } from '@/hooks/use-toast'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Car, ArrowLeft } from 'lucide-react'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { signIn, profile, loading } = useAuth()
  const navigate = useNavigate()
  const { toast } = useToast()

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    const { error } = await signIn(email, password)
    if (error) {
      toast({
        title: 'Erro ao fazer login',
        description: error.message,
        variant: 'destructive',
      })
    }
  }

  useEffect(() => {
    if (profile) {
      if (profile.role === 'financial') {
        navigate('/reports')
      } else if (profile.role === 'ultramaster' || profile.role === 'admin') {
        navigate('/management')
      } else {
        navigate('/dashboard')
      }
    }
  }, [profile, navigate])

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Carregando...
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-muted/30 p-4 relative">
      <Link to="/" className="absolute top-4 left-4 md:top-8 md:left-8">
        <Button variant="ghost" className="font-bold">
          <ArrowLeft className="h-4 w-4 mr-2" /> Voltar
        </Button>
      </Link>

      <Card className="w-full max-w-md shadow-xl border-primary/10">
        <CardHeader className="text-center space-y-2">
          <div className="mx-auto bg-primary text-primary-foreground p-3 rounded-xl w-16 h-16 flex items-center justify-center mb-4 shadow-sm">
            <Car className="w-8 h-8" />
          </div>
          <CardTitle className="text-2xl font-bold tracking-tight">
            Login Parkko
          </CardTitle>
          <p className="text-sm text-muted-foreground">
            Insira suas credenciais para acessar o sistema.
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Label>Email Corporativo</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="nome@empresa.com"
                className="h-12"
              />
            </div>
            <div className="space-y-2">
              <Label>Senha</Label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="••••••••"
                className="h-12"
              />
            </div>
            <Button
              type="submit"
              className="w-full h-12 text-lg font-bold shadow-md"
            >
              Acessar Painel
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  )
}
